module.exports = __webpack_public_path__ + "img/no-gps-marker.8ff69c96.svg";